export interface Input extends Marko.SVG.SVG {}

<svg ...input width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C12 1.44772 12.4477 1 13 1H18C18.5523 1 19 1.44772 19 2V7C19 7.55228 18.5523 8 18 8C17.4477 8 17 7.55228 17 7V4.41421L10.7071 10.7071C10.3166 11.0976 9.68342 11.0976 9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289L15.5858 3H13C12.4477 3 12 2.55228 12 2ZM5 3C3.34315 3 2 4.34315 2 6V15C2 16.6569 3.34315 18 5 18H14C15.6569 18 17 16.6569 17 15V11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11V15C15 15.5523 14.5523 16 14 16H5C4.44772 16 4 15.5523 4 15V6C4 5.44772 4.44772 5 5 5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H5Z"
        fill="currentColor"/>
</svg>
